import React, { useMemo } from "react";
import {
  TrackingProvider,
  initializeAnalytics,
} from "@local-logic/core/tracking";

// TODO Move this import to sdks/sdks-app/src/App.tsx once all SDKs are migrated
import "~/assets/styles/globals.css";

import { ValidateOptions } from "~/components/ValidateOptions";
import { LocalLogicProvider } from "~/context/LocalLogicProvider";
import { useStateManagerContext } from "~/context/stateManager";
import useIsMobile from "~/hooks/useIsMobile";
import { ProductNames } from "~/types";
import { ANALYTICS_SETTINGS } from "~/constants/analytics";

import { Content } from "./components/Content";
import { LocalContentProvider } from "./context";
import { schema } from "./schema";
import { LocalContentProps } from "./types";

initializeAnalytics(ANALYTICS_SETTINGS.localContent.key);

const LocalContent = () => {
  const { sdkState } = useStateManagerContext<LocalContentProps>();
  const isMobile = useIsMobile();
  const locale = sdkState.globalOptions?.locale || "en";

  const clientId = useMemo(() => {
    const clientKey = sdkState.apiKey?.split(".") ?? "";

    return clientKey[0].slice(3);
  }, [sdkState.apiKey]);

  return (
    <ValidateOptions
      sdk="Local Content"
      schema={schema}
      options={sdkState.options!}
    >
      <LocalLogicProvider
        environment={sdkState.globalOptions?.environment?.api}
        apiKey={sdkState.apiKey}
        appearance={sdkState.globalOptions?.appearance}
        locale={sdkState.globalOptions?.locale}
        product={ProductNames.LOCAL_CONTENT}
      >
        <TrackingProvider
          trackingPipelineSettings={{
            apiKey: sdkState.apiKey || "",
          }}
          analyticsSettings={ANALYTICS_SETTINGS.localContent}
          meta={{
            clientId,
            productName: ProductNames.LOCAL_CONTENT,
            productVersion: FULL_APP_VERSION,
          }}
          attributes={{
            location: {
              lat: sdkState.options?.lat,
              lng: sdkState.options?.lng,
            },
            host_url: document.referrer,
            locale,
            isMobile,
            mapProvider: sdkState.options?.mapProvider?.name,
          }}
          flags={{
            isDebugMode:
              import.meta.env.VITE_TRACKING_PIPELINE_DEBUG === "true",
          }}
        >
          <LocalContentProvider>
            <Content />
          </LocalContentProvider>
        </TrackingProvider>
      </LocalLogicProvider>
    </ValidateOptions>
  );
};

export default LocalContent;
